/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyAdminRepresentation
 */
export interface CompanyAdminRepresentation {
    /**
     * the unique identifier for the user within the company
     * @type {string}
     * @memberof CompanyAdminRepresentation
     */
    key: string;
}

/**
 * Check if a given object implements the CompanyAdminRepresentation interface.
 */
export function instanceOfCompanyAdminRepresentation(value: object): value is CompanyAdminRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function CompanyAdminRepresentationFromJSON(json: any): CompanyAdminRepresentation {
    return CompanyAdminRepresentationFromJSONTyped(json, false);
}

export function CompanyAdminRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyAdminRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
    };
}

export function CompanyAdminRepresentationToJSON(json: any): CompanyAdminRepresentation {
    return CompanyAdminRepresentationToJSONTyped(json, false);
}

export function CompanyAdminRepresentationToJSONTyped(value?: CompanyAdminRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
    };
}

